import type { ReactNode } from 'react';

export type ChipTone = 'neutral' | 'success' | 'warning' | 'error' | 'info' | 'premium' | 'art';

// Colores con contraste AA del texto sobre el fondo del chip (DESIGN.md v4). Siempre texto + punto, nunca solo color.
const tones: Record<ChipTone, string> = {
  neutral: 'bg-gray-100 text-gray-700',
  success: 'bg-green-soft text-success-text',
  warning: 'bg-warning text-white',
  error: 'bg-error text-white',
  info: 'bg-mist text-ink',
  premium: 'bg-yellow-soft text-ink',
  art: 'bg-green-soft text-green',
};

export function Chip({ tone = 'neutral', children, dot = true }: { tone?: ChipTone; children: ReactNode; dot?: boolean }) {
  return (
    <span className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-semibold leading-5 ${tones[tone]}`}>
      {dot && <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true" />}
      {children}
    </span>
  );
}
